import { useMemo } from 'react';
import { ConvertedRouteType } from '@lp/features/RoutePlanner/hooks/useConvertedRoute';
import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { RouteSchema } from '@lp/features/RoutePlanner';
import { CaseResourceType } from '@/api/apis/case';
import { AircraftLegResource, BaseLegResourceType } from '@/api/apis/route';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { DataCacheType } from '@/queries/consts';

export const CurrentRouteSchema = ({ segments, legs }: Pick<ConvertedRouteType, 'segments' | 'legs'>) => {
  const { organType } = useBaseCaseDetails();
  const { list } = useRouteLocations(DataCacheType.Snapshot);
  const { Aircraft: aircrafts } = useRouteResources(DataCacheType.Snapshot);

  const aircraftsList = useMemo(
    () =>
      aircrafts?.map<BaseLegResourceType<AircraftLegResource>>((a) => ({
        id: a.resourceId,
        type: CaseResourceType.Aircraft,
        data: a.data,
      })) || [],
    [aircrafts],
  );

  return (
    <div className="flex flex-col gap-3 bg-base-90 p-4 border-b-1 border-base-70 rounded-t-lg">
      <span className="text-l-cps text-base-30">CURRENT</span>
      <RouteSchema organType={organType} segments={segments} legs={legs} aircrafts={aircraftsList} locations={list} />
    </div>
  );
};
